import { requireSupabase } from './supabase';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export async function apiFetch(path, options = {}) {
  if (!backendUrl) {
    throw new Error('REACT_APP_BACKEND_URL is not configured.');
  }

  const client = requireSupabase();
  const { data, error } = await client.auth.getSession();
  if (error) throw error;
  if (!data.session?.access_token) {
    throw new Error('Your session has expired. Sign in again.');
  }

  const headers = new Headers(options.headers || {});
  headers.set('Authorization', `Bearer ${data.session.access_token}`);

  return fetch(`${backendUrl}/api${path}`, {
    ...options,
    headers,
  });
}
